"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenCleaner = exports.cookieCleaner = exports.emailCleaner = void 0;
var index_1 = require("./index");
exports.emailCleaner = (0, index_1.createPropCleaner)(/x?email/);
exports.cookieCleaner = (0, index_1.createPropCleaner)(/cookie/);
exports.tokenCleaner = (0, index_1.createPropCleaner)(/(x-)?(csrf-)?token/, true);
//# sourceMappingURL=props.js.map